import 'twin.macro'

import { useDeviceInfo } from 'hooks/useDeviceInfo'
import React, { FC } from 'react'
import tw from 'twin.macro'

interface ContactItemProps {
  link: string
  icon: React.ReactNode
  label: string
  placement?: 'footer' | 'header'
  caption?: string
}
const ContactItem: FC<ContactItemProps> = ({ icon, link, label, placement, caption }) => {
  const { isMobile } = useDeviceInfo()

  return (
    <div tw='flex items-center gap-2'>
      <div
        tw='sm:w-[32px] sm:h-[32px] h-[28px] w-[28px] flex items-center justify-center bg-tertiary rounded-full'
        css={[placement === 'footer' && tw`bg-secondary`]}
      >
        <a href={link}>{icon}</a>
      </div>

      <div tw='flex flex-col'>
        <p tw='text-primary'> {label}</p>
        {placement === 'footer' ? (
          <p tw='text-secondary text-s12 uppercase'> {caption}</p>
        ) : (
          !isMobile && <p tw='text-secondary text-s12 uppercase'> {caption}</p>
        )}
      </div>

      {/* {placement === 'footer' && (
        <div tw='flex flex-col'>
          <p tw='text-primary'> {label}</p>
          <p tw='text-secondary text-s12 uppercase'> {caption}</p>
        </div>
      )} */}
    </div>
  )
}

export default ContactItem
